import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { SubscriptionUpgradeTool } from "../../../containers/SubscriptionUpgradeTool";
import { Modal } from "@yoast/ui-library";

import * as styles from "./styles.module.scss";

const messages = defineMessages( {
	ariaLabel: {
		id: "upgradeSubscriptionModal.aria.label",
		defaultMessage: "Upgrade subscription",
	},
	header: {
		id: "upgradeSubscriptionModal.header",
		defaultMessage: "Upgrade subscription",
	},
	successHeader: {
		id: "upgradeSubscriptionModal.successHeader",
		defaultMessage: "Successfully upgraded!",
	},
} );

export const UpgradeSubscriptionModal = ( props ) => {
	const [ success, setSuccess ] = useState( false );


	useEffect( () => {
		if ( ! props.isOpen ) {
			setSuccess( false );
		}
	}, [ setSuccess, props.isOpen ] );

	return (
		<Modal
			isOpen={ props.isOpen }
			onClose={ props.onClose }
			aria-label={ messages.ariaLabel.defaultMessage }
		>
			<Modal.Panel>
				<Modal.Container>
					<Modal.Container.Header>
						<Modal.Title size={ "2" }>
							{
								success
									? <FormattedMessage { ...messages.successHeader } />
									: <FormattedMessage { ...messages.header } />
							}
						</Modal.Title>
					</Modal.Container.Header>
					<Modal.Container.Content>
						<div className={ styles.upgradeTool }>
							<SubscriptionUpgradeTool
								onCancel={ props.onClose }
								onUpgradeSuccess={ () => setSuccess( true ) }
							/>
						</div>
					</Modal.Container.Content>
				</Modal.Container>
			</Modal.Panel>
		</Modal>
	);
};

UpgradeSubscriptionModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
};
